import axios from "axios";
import {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function EditPack() {
    const [PackData, setPackData] = useState({
        "packcat": '',
        "packsubcat": '',
        "addedby": '',
        "ip_add": '',
    });
    const {id} = useParams();
    useEffect(() => {
        try {
            axios.get(baseUrl + 'edit-pack/' + id)
                .then(function (response) {
                    setPackData({
                        packcat: response.data.packcat,
                        packsubcat: response.data.packsubcat,
                    });
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    const handleChange = (event) => {
        setPackData({
            ...PackData,
            [event.target.name]: event.target.value
        });
    }
    const formSubmit = () => {
        const _formData = new FormData();
        _formData.append('packcat', PackData.packcat);
        _formData.append('packsubcat', PackData.packsubcat);
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        try {
            axios.put(baseUrl + 'edit-pack/' + id, _formData, {
                headers: {
                    'content-type': 'multiple/form-data'
                }
            })
                .then(function (response) {
                    if (response.status == 200 || response.status == 201) {
                        Swal.fire({
                            title: 'Data has been updated',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                    }
                    setTimeout(() => {
                        window.location.href = ('/add-pack');
                    }, 2000);
                });
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <section className="container mt-4">
            <div className="row">
                <div className='col-md-9 col-12 mb-2'>
                    <div className='card'>
                        <h4 className='card-header'>Edit Package Category</h4>
                        <div className='card-body'>
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Package Category</label>
                                    <input type="text" className="form-control" name="packcat" value={PackData.packcat}
                                           onChange={handleChange} id="packcat"/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Pack SubCategory</label>
                                    <input type="text" className="form-control" name="packsubcat"
                                           value={PackData.packsubcat}
                                           onChange={handleChange} id="packsubcat"/>
                                </div>

                                <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default EditPack;